import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import Button from '@atlaskit/button/new';
import { Text } from '@atlaskit/primitives/compiled';
import SuggestedEditIcon from '@atlaskit/icon-lab/core/suggested-edit';

import { TopLinksEmptyStateIllustration } from './TopLinksEmptyStateIllustration.tsx';

type TopLinksEmptyStateProps = {
	onSuggestDocs: () => void;
	isLoading: boolean;
};

export const TopLinksEmptyState = ({ onSuggestDocs, isLoading }: TopLinksEmptyStateProps) => (
	<div css={styles.container}>
		<TopLinksEmptyStateIllustration />
		<Text size="large" weight="medium" color="color.text">
			<FormattedMessage {...i18n.pinImportantDocs} />
		</Text>
		<div css={styles.buttonWrapper}>
			<Button
				appearance="default"
				onClick={onSuggestDocs}
				isLoading={isLoading}
				iconBefore={(iconProps) => <SuggestedEditIcon {...iconProps} label="" />}
			>
				<FormattedMessage {...i18n.suggestDocs} />
			</Button>
		</div>
	</div>
);

const styles = cssMap({
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		paddingInline: token('space.250'),
		width: '100%',
	},
	buttonWrapper: {
		paddingBlockStart: token('space.100'),
	},
});

const i18n = defineMessages({
	pinImportantDocs: {
		id: 'space-overview.smart-space-overview.top-docs-card.empty-state.pin-docs',
		defaultMessage: 'Pin important docs here',
		description:
			'Text shown in the empty state of the top docs card, encouraging users to pin documents.',
	},
	suggestDocs: {
		id: 'space-overview.smart-space-overview.top-docs-card.empty-state.suggest-docs',
		defaultMessage: 'Suggest docs',
		description:
			'Label for the button that suggests documents to pin in the top docs card empty state.',
	},
});
